import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import PlanService from "../../../services/PlanService";

// Pregled prikazuje isti PDF koji se dobija na "Preuzmi PDF" -
// ono sto se vidi ovde je identicno skinutom fajlu.
const Preview = () => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');

    useEffect(() => {
        let objectUrl = null;
        const previewData = JSON.parse(localStorage.getItem('previewData'));
        if (previewData) {
            PlanService.downloadPdf(previewData).then(response => {
                objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                setPdfUrl(objectUrl);
            }).catch(async (err) => {
                // Server salje objasnjenje sta je poslo naopako - prikazujemo ga
                try {
                    if (err.response && err.response.data && typeof err.response.data.text === 'function') {
                        const tekst = await err.response.data.text();
                        if (tekst && tekst.trim()) setErrorText(tekst);
                    }
                } catch (e) { /* ostaje podrazumevana poruka */ }
                setError(true);
            });
        }
        return () => { if (objectUrl) window.URL.revokeObjectURL(objectUrl); };
    }, [])

    if (error) {
        return (
            <div className="flex flex-col justify-center items-center w-full h-screen text-gray-500 px-8 text-center">
                <div className="font-semibold mb-2">Pregled nije mogao da se napravi.</div>
                <div>{errorText || 'Proveri da li je aplikacija pokrenuta, pa pokušaj ponovo.'}</div>
            </div>
        )
    }

    return (
        pdfUrl ?
            <iframe title="Pregled plana" src={pdfUrl} className="w-full" style={{ height: '100vh', border: 'none' }} />
            :
            <div className="flex justify-center items-center w-full h-screen text-gray-500">
                Priprema pregleda...
            </div>
    )
}

export default withRouter(Preview)
